import React, { useEffect, useState } from "react";
import circle from '../../../assets/img/circulogris.png';
import './ImageNameDescription.css'
import Options from '../Options/Options'

const ImageNameDescription = ({
    onClick = () => { },
    optionStyle={},
    options,
    description,
    srcImage,
    firstName,
    secondName,
    type,
    shouldDscriptionEllipsis = true,
    shouldEllipsis = false,
    typeOneText = ''
}) => {
    const [typeState, settypeState] = useState('')

    useEffect(() => {
        settypeState(type);


        return () => {

        }
    }, [type])



    return (
        <div className={`content-image-name ${typeState}`} onClick={onClick}>
            {srcImage ? <img onClick={onClick} alt="img" className="picture-image-name" onError={(e) =>
                e.target.src = circle} src={srcImage} /> :
                <img onClick={onClick} alt="img" className="picture-image-name" src={circle} />}
            <div className={`content-name-description${shouldEllipsis ?" content-name-description-elipsis":""}`}>
                <div className="full-name-image-name">
                    <span onClick={onClick} className={`first-name-image-name ${typeOneText}`}>{firstName}</span>
                    <span onClick={onClick} className={`second-name-image-name${shouldEllipsis ?" content-name-description-elipsis":""}`}> {secondName}</span>
                </div>
                <div className={shouldDscriptionEllipsis ? `description-image-name` : `description-image-name-overflow`}>{description}</div>
            </div>

            {options?.length > 0 && <Options style={optionStyle} options={options} />}
        </div>
    )
}

export default ImageNameDescription
